<template>
  <section class="init_box" style="background-color: white">
    <el-row>
      <el-col :span="6" style="margin-top: 15px">
        <el-button class="btn" size="small" v-if="btnRole.indexOf('137') != -1" type="primary"
          @click="clickShenHeBtn">设备审核</el-button>
        <el-button class="btn" size="small" type="primary" @click="batchwithdrawal"
          v-if="btnRole.indexOf('196') != -1">设备撤回</el-button>

        <el-button class="btn" size="small" type="info">导出台账</el-button>

        <!-- <el-button type="primary" size="small" style="float: right;margin-right: 15px;">搜索</el-button>
                <el-input placeholder="请输入查询厂家、编号、类型、名称" prefix-icon="el-icon-search" v-model="search"
                    style="width:18%;float: right;margin-right: 15px;">
                </el-input> -->
      </el-col>
      <!-- 筛选框-->
      <el-col :span="18" style="float: left; margin-top: 10px">
        <el-form :model="searchModel" :inline="true" style="float: right">
          <el-form-item label="使用部门">
            <!-- <el-cascader v-model="searchModel.company" style="width:100%;" clearable :options="companySelect"
                            :props="companyProps" placeholder="请选择使用部门" :show-all-levels="false" filterable></el-cascader> -->
            <el-cascader v-model="searchModel.company" style="width: 100%" :options="companySelect"
              :props="companyProps" clearable :show-all-levels="false" filterable placeholder="请选择使用部门"></el-cascader>
          </el-form-item>
          <el-form-item label="设备类型">
            <el-cascader v-model="searchModel.deviceType" style="width: 100%" clearable :options="deviceTypeSelect"
              :props="props" placeholder="请选择设备类型" :show-all-levels="false" filterable></el-cascader>
          </el-form-item>
          <el-form-item label="模糊搜索">
            <el-input placeholder="请输入查询厂家、编号、类型、名称" auto-complete="off" prefix-icon="el-icon-search"
              v-model="searchModel.search" style="width: 100%; margin-right: 55px" clearable>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="" size="small" @click="getDeviceinfo">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <!-- <el-button style="float: right;margin-right: 15px;" icon="iconfont icon-liebiao"></el-button> -->
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24">
        <el-dropdown :hide-on-click="false" style="margin-right: 15px; float: right">
          <i class="iconfont icon-liebiao"></i>
          <el-dropdown-menu slot="dropdown">
            <el-scrollbar style="height: 60vh"><!--作用是数据过多把表单数据的整体高度固定、多出的区域可以下拉展示-->
              <el-checkbox-group v-model="check">
                <el-dropdown-item v-for="(item, index) in checkList" :key="index">
                  <el-checkbox :label="item" :key="item"> </el-checkbox>
                </el-dropdown-item>
              </el-checkbox-group>
            </el-scrollbar>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
      <el-col :span="24" style="margin-top: 8px">
        <el-table :data="deviceData" ref="deviceTable" id="deviceTable" @selection-change="changeCheckBoxValue"
          :header-cell-style="{ background: '#eff3f6' }" stripe :row-key="getRowKeys" height="650" style="
            width: 99%;
            margin: 0px auto;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          ">
          <el-table-column fixed type="selection" width="55" :reserve-selection="true">
          </el-table-column>
          <el-table-column fixed type="index" label="序号" width="80">
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="item.prop == 'zcmc' && item.ispass" v-for="(item, index2) in deviceTable"
            :width="item.width" :prop="item.prop" :key="index2" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip>
            <template slot-scope="scope" v-if="item.prop == 'zcmc'">
              <el-link :underline="false" style="color: #4095e5; text-decoration: none" @click="toDetail(scope.row)">
                {{ scope.row.zcmc }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column v-for="(item, index1) in deviceTable" v-if="item.prop == 'glbh' && item.ispass"
            :width="item.width" :prop="item.prop" :key="index1" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip :row-key="(row) => {
              return row.classId;
            }
              ">
            <template slot-scope="scope" v-if="item.prop == 'glbh'">
              <el-link :underline="false" style="color: #4095e5; text-decoration: none" @click="toDetail(scope.row)">
                {{ scope.row.glbh }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column v-for="(item, index1) in deviceTable" v-if="item.prop == 'shid' && item.ispass"
            :width="item.width" :prop="item.prop" :key="index1" :label="item.label" :fixed="false" show-overflow-tooltip
            :row-key="(row) => {
              return row.classId;
            }
              ">
            <template slot-scope="scope" v-if="item.prop == 'shid'">
              <el-link :underline="false" style="color: #4095e5; text-decoration: none" @click="toDetail(scope.row)">
                {{ scope.row.shid }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column v-if="item.prop == 'sydw' && item.ispass" v-for="(item, index3) in deviceTable"
            :width="item.width" :prop="item.prop" :key="index3" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip>
            <template slot-scope="scope" v-if="item.prop == 'sydw'">
              {{ scope.row.companyname }}
            </template>
          </el-table-column>
          <el-table-column v-if="item.prop == 'yjfl' && item.ispass" v-for="(item, index4) in deviceTable"
            :width="item.width" :prop="item.prop" :key="index4" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip :formatter="formateYjfl">
            <!-- <template slot-scope="scope" v-if="item.label == '一级分类'">
                            {{ formateYjfl(scope.row.yjfl) }}
                        </template> -->
          </el-table-column>
          <el-table-column v-if="item.prop == 'ejfl' && item.ispass" v-for="(item, index5) in deviceTable"
            :width="item.width" :prop="item.prop" :key="index5" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip :formatter="formateEjfl">
            <!-- <template slot-scope="scope" v-if="item.label == '一级分类'">
                            {{ formateYjfl(scope.row.yjfl) }}
                        </template> -->
          </el-table-column>
          <el-table-column v-if="item.prop == 'zyfl' && item.ispass" v-for="(item, index6) in deviceTable"
            :width="item.width" :prop="item.prop" :key="index6" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip :formatter="formateZyfl">
            <!-- <template slot-scope="scope" v-if="item.label == '一级分类'">
                            {{ formateYjfl(scope.row.yjfl) }}
                        </template> -->
          </el-table-column>
          <el-table-column v-if="item.prop == 'xmfl' && item.ispass" v-for="(item, index7) in deviceTable"
            :width="item.width" :prop="item.prop" :key="index7" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip :formatter="formateXmfl">
            <!-- <template slot-scope="scope" v-if="item.label == '一级分类'">
                            {{ formateYjfl(scope.row.yjfl) }}
                        </template> -->
          </el-table-column>
          <el-table-column v-else-if="
            item.prop != 'glbh' &&
            item.prop != 'bz' &&
            item.prop != 'zcmc' &&
            item.prop != 'id' &&
            item.prop != 'shid' &&
            item.prop != 'sydw' &&
            item.prop != 'yjfl' &&
            item.prop != 'ehfl' &&
            item.prop != 'zyfl' &&
            item.prop != 'xmfl' &&
            item.prop != 'sbzt' &&
            item.prop != 'dbzt' &&
            item.ispass
          " :width="item.width" :prop="item.prop" :key="item.prop" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column v-if="item.prop == 'dbzt' && item.ispass" v-for="(item, index9) in deviceTable"
            :width="item.width" :prop="item.prop" :key="index9" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip>
            <template slot-scope="scope" v-if="item.prop == 'dbzt'">
              <span v-if="scope.row.dbzt == 1">在用</span>
              <span v-if="scope.row.dbzt == 0">可调拨</span>
              <!-- {{scope.row.dbzt  }}  -->
            </template>
          </el-table-column>
          <el-table-column v-if="item.prop == 'bz' && item.ispass" v-for="(item, index10) in deviceTable"
            :width="item.width" :prop="item.prop" :key="index10" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column v-if="item.prop == 'sbzt' && item.ispass" v-for="(item, index8) in deviceTable"
            align="center" :width="80" :prop="item.prop" :key="index8" :label="item.label" fixed="right"
            show-overflow-tooltip>
            <template slot-scope="scope" v-if="item.prop == 'sbzt'">
              <span v-if="scope.row.sbzt == 3" style="color: #4095e5">
                {{ scope.row.statusName }}</span>
              <span v-if="scope.row.sbzt == 47" style="color: red">{{
                scope.row.statusName
                }}</span>
              <span v-if="scope.row.sbzt == 48" style="color: rgb(211, 212, 218)">{{ scope.row.statusName }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <el-button @click="toDetail(scope.row)" type="text" size="small">详情</el-button>
              <el-button @click="withdraw(scope.row)" v-if="scope.row.sbzt == 3 && btnRole.indexOf('196') != -1"
                type="text" size="small">撤回</el-button>
              <el-button @click="clickUpdate(scope.row)" v-if="
                (scope.row.sbzt == 47 && btnRole.indexOf('194') != -1) ||
                (scope.row.sbzt == 48 && btnRole.indexOf('194') != -1)
              " type="text" size="small">编辑</el-button>
              <el-button @click="clickDelete(scope.row)" v-if="
                (scope.row.sbzt == 47 && btnRole.indexOf('195') != -1) ||
                (scope.row.sbzt == 48 && btnRole.indexOf('195') != -1)
              " type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top: 5px; height: 35px" v-if="total > 0">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
          :total="total" style="float: right">
        </el-pagination>
      </el-col>
    </el-row>
    <!-- 添加显示购物车按钮，如果复选框有选中让显示，否则不显示 -->
    <div style="
        position: fixed;
        top: 15%;
        left: 470px;
        height: 50px;
        width: 50px;
        color: #4095e5;
        font-size: 20px;
      " @click="checkBoxdialog = true" v-if="checkBoxData.length > 0">
      <!-- <i class="iconfont icon-icon-test" style="width:100%;height:100%;font-size: 40px;"></i> -->
      <el-badge :value="checkBoxNumber">
        <!-- <span class="iconfont icon-icon-test" style="width:100%;height:100%;font-size: 40px;"></span> -->
        <img src="../../../static/img/selects.png" style="width: 70%; height: 70%; font-size: 40px" />
      </el-badge>
    </div>
    <!-- 显示购物车列表 -->
    <el-dialog title="已选择设备" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="checkBoxdialog">
      <el-button type="primary" size="mini" @click="removeAllCheckbox"
        style="margin-top: -30px; float: left">清空内容</el-button>
      <el-table :data="checkBoxData" v-if="checkBoxNumber > 0" :header-cell-style="{ background: '#eff3f6' }"
        style="padding-top: 5px">
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column property="zcmc" label="资产名称"></el-table-column>
        <el-table-column property="zcbh" label="资产编号"></el-table-column>
        <el-table-column property="glbh" label="管理编号"></el-table-column>
        <el-table-column property="sbxh" label="设备型号"></el-table-column>
        <el-table-column label="操作" style="text-decoration: none">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="removeThisData(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 设备审核 -->
    <el-dialog title="设备审核" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="deviceExaminedialog" width="720px" @close="deviceExamineDialogClose">
      <!-- 每台设备的本次修改内容（旧值→新值），供审核人在通过/驳回前查看 -->
      <div v-if="examineDiffList.length > 0"
        style="max-height: 260px; overflow-y: auto; margin-bottom: 10px; border: 1px solid #f3d19e; background: #fdf6ec; border-radius: 4px; padding: 10px;">
        <div v-for="(d, di) in examineDiffList" :key="di" style="margin-bottom: 8px;">
          <div style="font-weight: bold; font-size: 13px; color: #303133;">
            {{ di + 1 }}. {{ d.zcmc }}（{{ d.glbh }}）
            <span v-if="d.hasDraft" style="font-weight: normal; color: #909399; font-size: 12px;">
              修改人：{{ d.editor || '-' }} {{ d.editTime || '' }}
            </span>
            <span v-else
              style="display:inline-block;background:linear-gradient(135deg,#409EFF,#2b85e4);color:#fff;font-size:12px;font-weight:bold;border-radius:12px;padding:2px 12px;margin-left:6px;box-shadow:0 1px 3px rgba(64,158,255,.4);">
              ✦ 新录入设备
            </span>
          </div>
          <div v-for="(f, fi) in changedFieldsOf(d)" :key="fi" style="line-height: 22px; font-size: 12px; padding-left: 14px;">
            {{ f.label }}：<span style="color:#909399;text-decoration:line-through">{{ f.old || '（空）' }}</span>
            <span style="margin:0 3px">→</span>
            <span style="color:#F56C6C;font-weight:bold">{{ f.new || '（空）' }}</span>
          </div>
          <div v-if="d.hasDraft && changedFieldsOf(d).length == 0" style="font-size: 12px; color: #909399; padding-left: 14px;">
            敏感字段无变化（可能为驳回后重新提交）
          </div>
        </div>
      </div>
      <el-form :model="deviceExamine" ref="deviceExamine" label-position="left" label-width="100px"
        style="width: 90%; margin-left: 5%">
        <el-form-item label="审核意见" prop="shyj" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
          <el-input placeholder="请输入审核意见" style="width: 100%" v-model="deviceExamine.shyj" />
        </el-form-item>
      </el-form>
      <el-button style="width: 150px" type="primary" @click="clickShenheByForm(1)">通过</el-button>
      <el-button style="width: 150px" type="danger" @click="clickShenheByForm(47)">驳回</el-button>
    </el-dialog>
  </section>
</template>
<script>
import {
  selectAllLable,
  selectByShenhe,
  examine,
  deleteDeviceinfoByid,
  withdrawDevice,
  findByUserIdCompanyTree,
  getTreeDeviceType,
  selectEditDiffBatch,
} from "../../api/api";

export default {
  name: "Exanube_shebeik",
  data() {
    return {
      checkBoxNumber: 0,
      checkBoxdialog: false,
      deviceExaminedialog: false,
      examineDiffList: [],//审核弹窗内展示的每台设备编辑差异
      searchModel: {},
      deviceTypeSelect: [],
      props: {
        label: "deviceTypeName",
        value: "id",
        children: "deviceTypes",
        expandTrigger: "click",
        emitPath: false,
        checkStrictly: true, //设置可以单选一级
      },
      checked: false,
      check: [],
      checkList: [],
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      deviceData: [],
      deviceTable: [],
      search: "",
      deviceTotalData: [],
      checkBoxData: [],
      deviceTypeData: [],
      companySelect: [],
      xmflData: [],
      zyflData: [],
      deviceStatuData: [],
      btnRole: [],
      deviceExamine: {
        shyj: "",
      },
      companyProps: {
        checkStrictly: true,
        label: "companyName",
        value: "companyCode",
        children: "zcompany",
        emitPath: false,
      },
    };
  },
  methods: {
    batchwithdrawal() {
      if (this.checkBoxData.length <= 0) {
        this.$message.warning("请选择一台或多台待设备");
      } else {
        var bo = true;
        var list = [];
        for (var i = 0; i < this.checkBoxData.length; i++) {
          list.push(this.checkBoxData[i].id);
          if (this.checkBoxData[i].sbzt != 3) {
            bo = false;
            break;
          }
        }
        if (bo) {
          this.$confirm("请确认是否撤回该操作, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            var map = {
              deviceId: list,
              userId: JSON.parse(localStorage.getItem("user")).userId,
            };
            withdrawDevice(map).then((datas) => {
              let { status, message, data } = datas;
              if (status == 400) {
                this.$message({
                  message: message,
                  type: "error",
                });
              } else if (status == 200) {
                this.$message.success("撤回成功");
                this.getDeviceinfo();
                this.checkBoxData = [];
              } else {
                this.$message({
                  message: "请求错误",
                  type: "error",
                });
              }
            });
          });
        } else {
          this.$message.warning("请确认已选设备都为待审核状态");
        }
      }

      // if (this.checkBoxData.length <= 0) {
      //     this.$message({
      //         message: "请选择一台或多台待审核设备",
      //         type: 'warning'
      //     });
      // }
    },
    //查找设备分类
    selectDeviceType() {
      let _parmas = {
        userId: JSON.parse(localStorage.getItem("user")).userId,
      };
      getTreeDeviceType(_parmas).then((datas) => {
        let { status, message, data } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error",
          });
        } else if (status == 200) {
          this.deviceTypeSelect = this.getTreeData(data);
          // debugger
        } else {
          this.$message({
            message: "请求错误",
            type: "error",
          });
        }
      });
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].deviceTypes.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].deviceTypes = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData(data[i].deviceTypes);
        }
      }
      return data;
    },
    //查找单位
    getCompanyTree() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      var companyCode = "";
      if (
        userinfo.userRole == 1 ||
        (userinfo.fjqx != null &&
          (userinfo.fjqx.indexOf("3") != -1 ||
            userinfo.fjqx.indexOf("4") != -1))
      ) {
        companyCode = "-1";
      } else {
        companyCode = userinfo.companyCode;
      }
      findByUserIdCompanyTree(companyCode).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.companySelect = this.getCompanyTreeData(data);
        }
      });
    },
    getCompanyTreeData(companyData) {
      for (let i = 0; i < companyData.length; i++) {
        if (companyData[i].zcompany.length > 0) {
          // children不为空时继续调用该方法
          this.getCompanyTreeData(companyData[i].zcompany);
        } else {
          // 最后一级没有数据将children变成undefined
          companyData[i].zcompany = undefined;
        }
      }
      return companyData;
    },
    getRowKeys(row) {
      return row.staffTypeId;
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.getDeviceinfo();
    },
    withdraw(row) {
      this.$confirm("请确认是否撤回该操作, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let userinfo = JSON.parse(localStorage.getItem("user"));
        var list = [];
        list.push(row.id);
        // debugger
        var map = {
          deviceId: list,
          userId: userinfo.userId,
        };
        withdrawDevice(map).then((datas) => {
          let { status, message, data } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error",
            });
          } else if (status == 200) {
            this.$message.success("撤回成功");
            this.getDeviceinfo();
          } else {
            this.$message({
              message: "请求错误",
              type: "error",
            });
          }
        });
      });
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getDeviceinfo();
    },
    //获取label不为id的label加在checkList里面
    getCheckList() {
      // debugger
      for (var i = 0; i < this.deviceTable.length; i++) {
        let id = "id";
        if (this.deviceTable[i].label.indexOf(id) < 0) {
          this.checkList.push(this.deviceTable[i].label);
        }
      }
    },
    //获取ispass为true的加载check里面
    getCheck() {
      for (var i = 0; i < this.deviceTable.length; i++) {
        // debugger
        let id = "id";
        if (this.deviceTable[i].label.indexOf(id) < 0) {
          if (this.deviceTable[i].ispass.indexOf("true") >= 0) {
            // debugger
            this.check.push(this.deviceTable[i].label);
          }
        }
      }
    },
    //查询所有label
    selectAllLables() {
      selectAllLable().then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          sessionStorage.setItem("deviceinfoLable", JSON.stringify(data));
          // debugger
          for (var i = 0; i < data.length; i++) {
            if (
              data[i].showPostion == 1 ||
              data[i].showPostion == 4 ||
              data[i].showPostion == 5 ||
              data[i].showPostion == 7
            ) {
              this.deviceTable.push(data[i]);
            }
          }
          this.getCheckList();
          this.getCheck();
        }
      });
      let userinfo = JSON.parse(localStorage.getItem("user"));
      this.btnRole = userinfo.role.menuId.split(",");
    },
    //获取复选框选中数据
    changeCheckBoxValue(val) {
      this.checkBoxData = val;
      this.checkBoxNumber = this.checkBoxData.length;
      // $.each(val,function(i,v){
      //     debugger
      //     this.checkBoxData.push(v);

      // })
    },
    //清空所有内容
    removeAllCheckbox() {
      this.checkBoxData = [];
      this.checkBoxNumber = this.checkBoxData.length;
      this.$refs.deviceTable.clearSelection(); //清除所有选中复选框
      this.checkBoxdialog = false;
    },
    //移除一条选中内容
    removeThisData(row) {
      let newCheckBoxData = [];
      for (var i = 0; i < this.checkBoxData.length; i++) {
        if (this.checkBoxData[i].id != row.id) {
          // debugger
          newCheckBoxData.push(this.checkBoxData[i]);
        }
      }
      this.checkBoxData = newCheckBoxData;
      if (this.checkBoxData.length > 0) {
        this.$refs.deviceTable.store.states.selection.map((item, index) => {
          if (item.id === row.id) {
            this.$refs.deviceTable.store.states.selection.splice(index, 1);
          }
        });
      } else {
        this.$refs.deviceTable.clearSelection(); //清除所有选中复选框
        this.checkBoxdialog = false;
      }
      this.checkBoxNumber = this.checkBoxData.length;
    },
    // 查询所有分类信息
    getfenleiData() {
      this.zyflData = JSON.parse(sessionStorage.getItem("zyflData"));
      this.deviceTypeData = JSON.parse(
        sessionStorage.getItem("deviceTypeData")
      );
      this.deviceStatuData = JSON.parse(
        sessionStorage.getItem("deviceStatuData")
      );
    },
    // 查询需要审核设备信息
    getDeviceinfo() {
      // debugger
      let _params = {
        content: this.searchModel.search,
        pageIndex: this.pageIndex,
        pageSize: this.pagesize,
        sydw: this.searchModel.company,
        ejfl: this.searchModel.deviceType,
        userId: JSON.parse(localStorage.getItem("user")).userId,
      };
      selectByShenhe(_params).then((datas) => {
        let { status, message, data } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error",
          });
        } else if (status == 200) {
          this.deviceData = data.list;
          // this.deviceData = this.deviceTotalData.slice((this.pageIndex - 1) * this.pagesize, this.pageIndex * this.pagesize)
          this.total = data.total;
        } else {
          this.$message({
            message: "请求错误",
            type: "error",
          });
        }
      });
    },
    // 格式化一级分类列
    formateYjfl(row, colum) {
      let yjfl = "";
      for (var i = 0; i < this.deviceTypeData.length; i++) {
        if (row.yjfl == this.deviceTypeData[i].id) {
          yjfl = this.deviceTypeData[i].deviceTypeName;
          return yjfl;
        }
      }
    },
    // 格式化二级分类列
    formateEjfl(row, colum) {
      let ejfl = "";
      for (var i = 0; i < this.deviceTypeData.length; i++) {
        if (row.ejfl == this.deviceTypeData[i].id) {
          ejfl = this.deviceTypeData[i].deviceTypeName;
          return ejfl;
        }
      }
    },
    // 格式化专业分类列
    formateZyfl(row, colum) {
      let zyfl = "";
      for (var i = 0; i < this.zyflData.length; i++) {
        if (row.zyfl == this.zyflData[i].id) {
          zyfl = this.zyflData[i].name;
          return zyfl;
        }
      }
    },
    // 格式化项目分类列
    formateXmfl(row, colum) {
      let xmfl = "";
      for (var i = 0; i < this.xmflData.length; i++) {
        if (row.xmfl == this.xmflData[i].id) {
          if (row.zyfl == this.xmflData[i].mId) {
            xmfl = this.xmflData[i].name;
            return xmfl;
          }
        }
      }
    },
    toDetail(data) {
      sessionStorage.setItem("deviceinfoDetail", JSON.stringify(data));
      sessionStorage.setItem("from", "examine");
      if (data.sbzt == 47) {
        sessionStorage.setItem("examineResult", "fail");
      } else {
        sessionStorage.setItem("examineResult", "loading");
      }
      //添加路由跳转至查看设备
      this.$router.push({
        path: "DeviceDetail",
      });
    },
    // 点击录入审核
    clickShenHeBtn() {
      if (this.checkBoxData.length <= 0) {
        this.$message({
          message: "请选择一台或多台待审核设备",
          type: "warning",
        });
      } else {
        // 打开审核弹窗前，批量拉取选中设备的编辑差异，供审核人参考
        let ids = this.checkBoxData.map((item) => item.id).join();
        this.examineDiffList = [];
        selectEditDiffBatch(ids).then((datas) => {
          if (datas.status == 200) {
            this.examineDiffList = datas.data || [];
          }
        });
        this.deviceExaminedialog = true;
      }
    },
    // 取某台设备差异中有变化的字段
    changedFieldsOf(item) {
      if (!item || !item.fields) return [];
      return item.fields.filter((f) => f.changed);
    },
    clickShenheByForm(result) {
      let _params = {
        id: this.checkBoxData.map((item) => item.id).join(),
        result: result,
        shyj: this.deviceExamine.shyj,
        userId: JSON.parse(localStorage.getItem("user")).userId,
      };
      examine(_params).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.$message({ message: message, type: "success" });
          setTimeout(() => {
            this.checkBoxData = [];
            this.checkBoxNumber = this.checkBoxData.length;
            this.$refs.deviceTable.clearSelection(); //清除所有选中复选框
            this.checkBoxdialog = false;
            this.deviceExaminedialog = false;
            this.getDeviceinfo();
          }, 1500);
        }
      });
    },
    deviceExamineDialogClose() {
      this.deviceExamine.shyj = "";
    },

    // 点击删除
    clickDelete(row) {
      this.$confirm("此操作将永久删除该条信息，是否确定删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let _params = {
          id: row.id,
          userId: JSON.parse(localStorage.getItem("user")).userId,
        };
        deleteDeviceinfoByid(_params).then((datas) => {
          let { message, status } = datas;
          if (status == 200) {
            this.$message({ message: "删除成功", type: "success" });
            this.removeAllCheckbox();
            this.getDeviceinfo();
          } else {
            this.$message({ message: "删除失败", type: "error" });
          }
        });
      });
    },
    // 点击编辑
    clickUpdate(data) {
      sessionStorage.setItem("deviceUpdate", JSON.stringify(data));
      sessionStorage.setItem("from", "examine");
      if (data.sbzt == 47 || data.sbzt == 48) {
        sessionStorage.setItem("examineResult", "fail");
      } else {
        sessionStorage.setItem("examineResult", "loading");
      }
      //添加路由跳转至修改设备
      this.$router.push({
        path: "deviceinfoUpdate",
      });
    },
  },
  created() {
    this.selectAllLables();
    this.getDeviceinfo();
    this.getCompanyTree();
    this.selectDeviceType();
  },
  watch: {
    check(newVal) {
      if (newVal) {
        var arr = this.checkList.filter((i) => newVal.indexOf(i) < 0); //未选中
        this.deviceTable.map((i) => {
          if (arr.indexOf(i.label) !== -1) {
            i.ispass = false;
          } else {
            i.ispass = true;
            this.$nextTick(() => {
              this.$refs.deviceTable.doLayout();
            });
          }
        });
      }
    },
  },
};
</script>
<style>
.el-checkbox__inner {
  border: 1px solid #606266 !important;
}
</style>
<style lang="less" scoped>
.btn {
  float: left;
  margin-left: 5px;
}

#deviceTable {
  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px;
    /*滚动条宽度*/
    height: 15px;
    /*滚动条高度*/
    margin-top: 100px;
  }

  /* 给固定列设置下边距 */
  /deep/ .el-table__fixed {
    height: auto !important;
    bottom: 15px !important;
    /* 具体值是多少根据你横向滚动条的高度进行设置 */
  }

  /deep/ .el-table__fixed-left {
    height: 100% !important;
  }

  /* 去掉固定列下方的横线 */
  /deep/ .el-table__fixed::before,
  .el-table__fixed-left::before {
    display: none;
  }

  /*定义滚动条轨道 内阴影+圆角*/
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
    border-radius: 10px;
    background: #ededed;
  }

  /*定义滑块 内阴影+圆角*/
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #cfcbcb;
  }

  /deep/ .el-table__fixed-body-wrapper {
    height: calc(100% -57px) !important;
    padding-bottom: 17px;
    box-sizing: content-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/device/Examine_shebeik.vue